module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card",
    class: {
      'card--sent': _vm.requestSent
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.requestSent) ? _c('div', {
    key: "default",
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "lock-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 48 56",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4",
      "y": "24",
      "width": "40",
      "height": "28",
      "rx": "6",
      "stroke": "#2ECC71",
      "stroke-width": "3",
      "fill": "#2ECC71",
      "fill-opacity": "0.1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 24V16C10 8.268 16.268 2 24 2C31.732 2 38 8.268 38 16V24",
      "stroke": "#2ECC71",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "24",
      "cy": "37",
      "r": "4",
      "fill": "#2ECC71"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "41",
      "x2": "24",
      "y2": "46",
      "stroke": "#2ECC71",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Você ainda não tem acesso"), _c('br'), _vm._v("ao PlaceMarket\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          Para acessar o painel, é necessário solicitar a liberação com\n          nosso time comercial."), _c('br'), _vm._v("\n          Após a ativação, seu acesso ficará disponível automaticamente.\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleRequest
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("SOLICITAR LIBERAÇÃO")]) : _c('span', {
    staticClass: "loader"
  })]), _vm._v(" "), _c('p', {
    staticClass: "helper-text"
  }, [_vm._v("\n          Entre em contato com nosso time comercial e garanta seu acesso ao painel.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n          ← Voltar para o login\n        ")])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "Logo",
      "width": "250",
      "height": "60"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de90325","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error/AccessError.vue
// module id = 3273
// module chunks = 0